
export const capitalize = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const toSentenceCase = (str: string) => {
    const sentence = str.replace(/([A-Z])/g, " $1").trim();
    return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase();
};
